var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Idle_12_Question"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_12_Question",
    clipPath: "url(#clip-Icons_Idle_12_Question)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_12_Question-2",
    "data-name": "Icons_Idle_12_Question",
    transform: "translate(1.567 -13.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(217.228 518.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M99.066,156.6c-18.416,6.5-34.3,29.971-30.693,53.8,5.416,35.749,41.165,43.332,64.636,35.749,26-8.305,42.609-51.637,19.86-77.275-13.722-15.166-37.554-18.055-53.8-12.277",
    transform: "translate(-67.857 -153.834)",
    fill: "#ffe149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(179.397 13.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M86.7,217.354a108.884,108.884,0,0,0,22.027,1.805c25.638,0,42.971-3.25,45.859-30.693,2.528-23.11-11.555-49.831,10.472-66.8,18.055-14.083,54.165-6.5,69.692,8.666,29.971,29.249,9.75,82.691-24.193,97.857-29.249,13.361-63.553,32.138-78,62.47-9.389,19.86-18.055,44.415-20.583,66.442-7.583,66.081,2.167,99.663,39.721,99.663,55.248,0,42.971-102.913,87.024-125.662,75.83-39,113.745-77.275,102.551-179.826C333.691,82.3,291.081,17.307,214.89,14.057c-33.221-1.444-92.441,16.972-127.106,63.914-14.083,19.138-29.249,46.943-29.971,71.5-.361,18.777-3.25,46.943,12.638,60.3C75.145,213.743,80.923,215.91,86.7,217.354Z",
    transform: "translate(-57.38 -13.978)",
    fill: "#ffe149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(10.648 18.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M186.329,556.954a8.5,8.5,0,0,1-2.889-.722C71.139,507.123,1.808,391.933,11.558,269.521,20.947,151.082,104,48.891,218.105,15.67A9.027,9.027,0,0,1,223.161,33C115.915,64.057,38.279,159.748,29.252,270.966,20.224,385.794,84.861,493.762,190.3,539.622c4.694,1.805,6.5,7.222,4.694,11.916a8.553,8.553,0,0,1-8.666,5.416",
    transform: "translate(-10.648 -15.296)",
    fill: "#c1c1c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(337.167 64.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M109.117,542.889a8.812,8.812,0,0,1-7.944-7.583,9.507,9.507,0,0,1,7.222-10.472A269.415,269.415,0,0,0,331.552,280.011c7.222-91.719-32.138-179.465-105.079-235.8A9.027,9.027,0,0,1,237.306,29.77a288.008,288.008,0,0,1-126.023,512.4,2.653,2.653,0,0,1-2.167.722",
    transform: "translate(-101.072 -28.013)",
    fill: "#c1c1c1"
  }))))));
};
export default __webpack_public_path__ + "static/media/Icons_Idle_12_Question.df136a9a.svg";
export { SvgComponent as ReactComponent };